import { IVideoStream } from "@app/main/components/videos/models/ICameraChannel";
import { TranslationService } from "@app/services/translation.service";
import { IVehicle } from "@interfaces/IVehicle";
import * as angular from "angular";
import { CameraStatusService } from "../services/camera-status.service";
import { CameraService } from "../services/camera.service";
import "./liveStreamVideo.scss";

interface IComponentBindings {
    vehicle: IVehicle;
    cameraOnline: boolean;
}

class ComponentController implements angular.IComponentController, IComponentBindings {
    vehicle: IVehicle;
    cameraOnline: boolean;

    loading = false;
    allStreamsOffline = false;
    
    highQuality = false;

    channels: IVideoStream[];
    visibleChannels: IVideoStream[];

    lastStreamOnlineTime: Date;

    get isError(): boolean {
        return !this.cameraOnline || this.allStreamsOffline;
    }

    get error(): string {
        if (!this.cameraOnline) {
            return this.translationService.translate('liveStreamVideo.deviceOffline');
        }

        if (this.cameraOnline && this.allStreamsOffline) {
            return this.translationService.translate('liveStreamVideo.deviceLowSignal');
        }

        return "";
    }

    static $inject = ["$scope", "cameraService", "cameraStatusService", "translationService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly cameraService: CameraService,
        private readonly cameraStatusService: CameraStatusService,
        private readonly translationService: TranslationService
    ) { }

    $onChanges(changes: angular.IOnChangesObject): void {
        if (changes['vehicle'] && changes['vehicle'].currentValue["Id"] == changes['vehicle'].previousValue["Id"]) {
            return;
        }

        this.getLiveStreamDevice();
    }

    onQualityChange(): void {
        // Most probably needed because v-toggle button is
        // Angular2+ component and two way binding works
        // not completely fine in AngularJS component. 
        // We will likely remove it on full upgrade.
        this.$scope.$applyAsync();
    }

    toggleChannelVisibility(channel: IVideoStream) {
        if (!channel) {
            return;
        }

        channel.visible = !channel.visible;
        this.updateVisibleChannelList();
    }

    updateVisibleChannels($event: IVideoStream[]) {
        this.visibleChannels = $event;
        this.$scope.$applyAsync();
    }

    onRestartStreams(): void {
        this.getLiveStreamDevice();
    }

    // ---

    private updateVisibleChannelList() {
        this.visibleChannels = this.channels.filter(c => c.visible);
    }

    private getLiveStreamDevice(): void {
        if (!this.cameraOnline) {
            return;
        }

        this.loading = true;
        this.allStreamsOffline = true;

        this.channels = [];

        this.cameraService
            .getLiveStreamUrls(this.vehicle.Id, null)
            .then(channels => {
                if (channels.length <= 0) {
                    return;
                }

                this.channels = channels.filter(channel => channel.IsActive);

                if (this.channels.some(c => c.StreamUrl)) {
                    this.allStreamsOffline = false;
                }
            })
            .finally(() => {
                this.loading = false;
           
                if (this.allStreamsOffline) {
                    this.cameraStatusService.forceStatusUpdate();
                }

                this.$scope.$applyAsync();
            });
    }
}

export class LiveStreamVideoComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            vehicle: "<",
            cameraOnline: "<"
        };

        this.controller = ComponentController;
        this.template = require("./liveStreamVideo.html");
    }
}
